// idle-trigger.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import {environment} from "../../environments/environment";

@Injectable({ providedIn: 'root' })
export class IdleTriggerService {
    private trigger$ = new Subject<void>();

    triggerStartWatching() {
        this.trigger$.next(undefined);
        if (!environment.production) {
            console.log('starting trigger');
        }
    }

    onTrigger$() {
        return this.trigger$.asObservable();
    }
}
